export const ONE_SECOND_IN_MS = 1_000;
export const ONE_MINUTE_IN_MS = 60 * ONE_SECOND_IN_MS;
